import { FrownIcon, MehIcon, SmileIcon as LucideSmileIcon } from 'lucide-react';

interface SmileIconProps {
  variant?: 'happy' | 'sad' | 'neutral';
  size?: number;
}

const SENTIMENT_ICON = {
  happy: { Icon: LucideSmileIcon, className: 'text-success' },
  neutral: { Icon: MehIcon, className: 'text-muted-foreground' },
  sad: { Icon: FrownIcon, className: 'text-destructive' },
} as const;

export const SmileIcon = ({ variant = 'neutral', size = 24 }: SmileIconProps) => {
  const { Icon, className } = SENTIMENT_ICON[variant];

  return <Icon size={size} className={className} />;
};
